import styled from 'styled-components';

interface ImageCounterRightBottomProps {
  currentPageNum: number;
  totalPageNum: number;
}

export const ImageCounterRightBottom = ({ currentPageNum, totalPageNum }: ImageCounterRightBottomProps) => {
  return (
    <ImageNumberWrapper
      className={
        'absolute w-[53px] h-[27px] rounded-full bottom-[13px] right-[18px] z-50 flex justify-center items-center backdrop-blur-sm shadow'
      }
    >
      <ImageNumber
        className={'text-fontPrimary text-body2 text-[12px] font-medium z-100'}
      >{`${currentPageNum} / ${totalPageNum}`}</ImageNumber>
    </ImageNumberWrapper>
  );
};

const ImageNumberWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
`;

const ImageNumber = styled.span`
  color: white;

  white-space: nowrap;
`;
